export default {
  header: {
    projectName: '项目名称',
    export: '导出',
    debug: '调试',
    success: '成功',
    failed: '失败',
    generating: '正在合成视频...',
    updateNameFailed: '更新项目名称失败',
    menu: '菜单',
    settings: '设置',
    shortcuts: '键盘快捷键',
    about: '关于',
    darkMode: '深色模式',
    lightMode: '浅色模式',
    settingsComingSoon: '设置功能即将推出',
    shortcutsComingSoon: '键盘快捷键功能即将推出',
    aboutComingSoon: '关于信息即将推出',
    language: '语言',
    dimensions: '尺寸',
    canvas: '画布',
    view: '显示',
    general: '通用'
  },
  menu: {
    media: '媒体库',
    text: '文字'
  },
  loading: {
    core: '核心加载中...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: '公开测试版',
    newProject: '新建项目',
    backupFolder: '备份文件夹',
    documentation: '文档',
    recentProjects: '最近项目',
    viewAll: '查看全部 ({count})',
    noProjects: '暂无项目。创建您的第一个项目开始吧！',
    login: '登录',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: '博客',
    projectCreated: '项目已创建',
    projectCreatedDesc: '新项目创建成功',
    projectDeleted: '项目已删除',
    projectDeletedDesc: '项目删除成功',
    deleteConfirmation: '您确定要删除此项目吗？此操作无法撤销。',
    migrationFailed: '迁移失败',
    migrationFailedDesc: '无法从 localStorage 迁移数据',
    loadFailed: '加载失败',
    loadFailedDesc: '无法加载项目列表',
    creationFailed: '创建失败',
    creationFailedDesc: '无法创建新项目',
    deletionFailed: '删除失败',
    deletionFailedDesc: '无法删除项目'
  },
  timeline: {
    autoSaveFailed: '自动保存失败',
    autoSaveFailedDesc: '无法自动保存项目',
    loadFailed: '加载失败',
    loadFailedDesc: '无法加载项目。正在重定向到首页...',
    mainTrack: '主轨道',
    undo: '撤销',
    redo: '重做',
    split: '分割',
    delete: '删除'
  },
  attributes: {
    properties: '属性',
    position: '位置',
    scale: '缩放',
    animation: '动画',
    basic: '基础',
    mute: '静音',
    text: '文字',
    fontSize: '字号',
    content: '内容',
    fontFamily: '字体',
    direction: '文字方向',
    color: '颜色',
    stroke: '描边',
    background: '背景',
    video: '视频',
    rotate: '旋转',
    backgroundColor: '背景颜色',
    opacity: '不透明度',
    blend: '混合',
    filter: '滤镜',
    effect: '特效',
    transition: '转场',
    speed: '速度',
    volume: '音量'
  },
  router: {
    timeline: '视频编辑器',
    preview: '预览',
    storyboard: 'Storyboard - AI 视频代理'
  },
  placeholder: {
    text: '请输入文字内容',
    input: '请输入'
  },
  error: {
    parseAudio: '解析音频失败',
    parseImage: '解析图片失败',
    parseVideo: '解析视频失败',
    noProject: '请先创建或打开项目',
    invalidFileType: '无效的文件类型'
  },
  media: {
    video: '视频',
    image: '图片',
    audio: '音频',
    dropToUpload: '拖拽文件到此处上传'
  },
  common: {
    defaultText: '文本内容',
    delete: '删除'
  }
};
